import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { GetRolesFromUserName, GetUsuarioBy, } from '@/modules/system/usuario/usuario.service';
import { Logar, SetPermissoes, } from '@/modules/system/auth/application/auth.service';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import { useRef, useContext, useCallback } from 'react';

export default function LoginTradicional() {
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const context = useContext(MyContext);
  if (!context)
    throw new Error('LoginTradicional deve ser usado dentro de um MyProvider');

  const { state, setState } = context;

  const buscarPermissoes = useCallback(
    async (username: string) => {
      try {
        const roles = await GetRolesFromUserName(username);
        SetPermissoes(roles);
        navigate(Links.Index);
      } catch (error) {
        toast.error('Erro ao buscar permissões: ' + String(error));
      }
    },
    [navigate],
  );

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const username = usernameRef.current?.value?.trim();
    const password = passwordRef.current?.value;

    if (!username || !password) {
      toast.warn('Preencha todos os campos.');
      return;
    }

    try {
      await Logar(username, password);
      const userInfo = await GetUsuarioBy(username);

      setState({
        ...state,
        username: userInfo.username || username,
        nome: userInfo.pessoa?.nome
          ? `${userInfo.pessoa?.nome}`.trim()
          : username,
        cor_fonte_zebrado_tabela: userInfo.corletratabela,
        cor_fundo_zebrado_tabela: userInfo.corfundotabela,
        modulo: undefined,
        navbar: true,
      });

      await buscarPermissoes(username);
    } catch (error) {
      toast.error(String(error));
    }
  };

  return (
    <form className="signin-form" onSubmit={handleSubmit} method="post">
      <div className="loginform-group mb-3">
        <label htmlFor="username" className="loginlabel">
          Nome de Usuário
        </label>
        <input
          ref={usernameRef}
          id="username"
          name="username"
          type="text"
          className="form-control"
          autoComplete="username"
          title="Nome de Usuário"
          required
        />
      </div>

      <div className="loginform-group mb-4">
        <label htmlFor="password" className="loginlabel">
          Senha
        </label>
        <input
          ref={passwordRef}
          id="password"
          name="password"
          type="password"
          className="form-control"
          autoComplete="off"
          title="Senha"
          required
        />
      </div>

      <div className="loginform-group">
        <button id="acessar"
          type="submit"
          className="form-control loginbtn loginbtn-primary submit px-3"
        >
          Acessar
        </button>
      </div>

      <div className="loginform-group d-md-flex">
        <div className="text-md-right">
          <Link to={Links.Recuperar} title="Esqueceu a senha?">
            Esqueceu sua senha.
          </Link>
          <Link
            to={Links.Auth_Obter_Token}
            className="ms-4"
            title="Quer receber um token para acesso?"
          >
            Login por token.
          </Link>
        </div>
      </div>
    </form>
  );
}
